"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodcastPlayerControllers = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const _1 = require("./");
const PodcastPlayerControllers = ({ podcastLink, audioRef, }) => {
    const [activeModal, setActiveModal] = React.useState(null);
    const closeModal = () => {
        if (activeModal) {
            setActiveModal(null);
        }
    };
    React.useEffect(() => {
        const timeoutId = setTimeout(() => {
            document.addEventListener('click', closeModal);
        }, 0);
        return () => {
            clearTimeout(timeoutId);
            document.removeEventListener('click', closeModal);
        };
    }, [activeModal]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "podcast-player-controllers gap-2xs relative flex items-center", children: [(0, jsx_runtime_1.jsx)(_1.PodcastPlayerVolume, { audioRef: audioRef, activeModal: activeModal, setActiveModal: setActiveModal }), (0, jsx_runtime_1.jsx)(_1.PodcastPlayerSpeed, { audioRef: audioRef, activeModal: activeModal, setActiveModal: setActiveModal }), (0, jsx_runtime_1.jsx)(_1.PodcastPlayerPodBeanLink, { src: podcastLink })] }));
};
exports.PodcastPlayerControllers = PodcastPlayerControllers;
